function formatMoneyShopify(cents, format) {
  let normalizedCents = cents;

  if (typeof normalizedCents === "string") {
    normalizedCents = normalizedCents.replace(/[^\d-]/g, "");
  }

  normalizedCents = Number(normalizedCents);

  if (isNaN(normalizedCents) || normalizedCents == null) {
    normalizedCents = 0;
  }

  const value = new Intl.NumberFormat("da-DK", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(normalizedCents / 100);

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString =
    format ||
    (typeof Shopify !== "undefined" && Shopify.money_format) ||
    "{{ amount_no_decimals }}";

  return formatString.replace(placeholderRegex, value);
}

function updateOpticianPriceVisibility() {
  const averageOpticianPriceElements = document.querySelectorAll('.average-optician-price');
  
  averageOpticianPriceElements.forEach(element => {
    const priceValue = parseFloat(element.getAttribute('data-optician-price') || '0');
    
    if (priceValue === 0) {
      element.classList.add('hidden');
    } else if (element.classList.contains('hidden')) {
      element.classList.remove('hidden');
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const groupIds = {
    thickness: [
      "glass-thickness-one",
      "glass-thickness-two",
      "glass-thickness-three",
      "glass-thickness-four",
    ],
    coating: ["glass-coating-one", "glass-coating-two", "glass-coating-three", "glass-coating-four", "glass-coating-five"],
    extras: ["extras-one", "extras-two", "extras-three", "extras-four"],
    progressive : ["progressive-lenses-one", "progressive-lenses-two", "progressive-lenses-three", "progressive-lenses-four", "progressive-lenses-five"]
  };

  const purposeIds = [
    "glass-purpose-one",
    "glass-purpose-two", 
    "glass-purpose-three",
    "glass-purpose-four",
    "glass-purpose-five"
  ];

  const sunglassesIds = [
    "sunglasses-type-one",
    "sunglasses-type-two",
    "sunglasses-type-three",
    "sunglasses-type-four",
  ];

  const variantPriceInput = document.querySelector("#variant_price");
  const variantCompareAtPriceInput = document.querySelector(
    "#variant_compare_at_price"
  );
  const addToCartButton = document.querySelector(".add-to-cart-price");
  const addToCartCompareAtPrice = document.querySelector(".add-to-cart-compare-at-price");
  const addToCartButtonPrice = document.querySelector(
    ".sticky-navbar-buy-buttons .add-to-cart-price"
  );
  const averageOpticianPriceElement = document.querySelector(
    ".average-optician-price-content .metafield-money"
  );
  const averageOpticianPriceSpan = document.querySelector("[average-optician-price]");
  const selectedSubproductNamesElement = document.querySelector(".selected-subproduct-names");
  const productPageElement = document.querySelector("product-page");
  const subscriptionProductElement = productPageElement.querySelector(".subscription-product");
  const subscriptionInput = subscriptionProductElement ? subscriptionProductElement.querySelector(".subscription-input") : null;
  const subscriptionBanner = document.querySelector(".subscription-banner");
  const subscriptionProductSavedAmount = document.querySelector(".subscription-product-saved-amount");

  function logTotalPrices() {
    let totalPrice = 0;
    let totalCompareAtPrice = 0;
    let totalAverageOpticianPrice = 0;
    let selectedVariantTitles = [];

    let originalMetafieldValue = 0;
    if (productPageElement) {
      const originalValue = productPageElement.dataset.averageOpticianPrice;
      if (originalValue) {
        originalMetafieldValue = parseFloat(originalValue);
      }
    }

    const selectedPurposeInputs = purposeIds
      .map((id) => document.getElementById(id))
      .filter((input) => input && input.checked);

    selectedPurposeInputs.forEach((input) => {
      const variantTitle = input.dataset.variantTitle;
      if (variantTitle) {
        selectedVariantTitles.push(variantTitle);
      }

      const averageOpticianPrice = input.dataset.averageOpticianPrice;
      if (averageOpticianPrice) {
        const priceValue = parseFloat(averageOpticianPrice);
        if (!isNaN(priceValue)) {
          totalAverageOpticianPrice += priceValue;
        }
      }

      const priceAttr = input.getAttribute("variant-price");
      const compareAttr = input.getAttribute("variant-compare-at-price");

      let price = parseFloat(priceAttr);
      if (isNaN(price) || priceAttr === null || priceAttr === undefined) {
        price = 0;
      }

      let compareAtPrice = parseFloat(compareAttr);
      if (
        isNaN(compareAtPrice) ||
        compareAttr === null ||
        compareAttr === undefined
      ) {
        compareAtPrice = 0;
      }

      totalPrice += price;
      totalCompareAtPrice += compareAtPrice;
    });

    for (const category in groupIds) {
      const selectedInputs = groupIds[category]
        .map((id) => document.getElementById(id))
        .filter((input) => input && input.checked);

      selectedInputs.forEach((input) => {
        const averageOpticianPrice = input.dataset.averageOpticianPrice;
        if (averageOpticianPrice) {
          const priceValue = parseFloat(averageOpticianPrice);
          if (!isNaN(priceValue)) {
            totalAverageOpticianPrice += priceValue;
          }
        }
        
        if (input.id !== "extras-three") {
          const variantProductTitle = input.dataset.variantTitle;
          if (variantProductTitle) {
            selectedVariantTitles.push(variantProductTitle);
          }
        }
      });

      if (
        category === "extras" &&
        selectedInputs.some((input) => input.id === "extras-three")
      ) {
        const checkedSunglasses = sunglassesIds
          .map((id) => document.getElementById(id))
          .find((input) => input && input.checked);

        if (checkedSunglasses) {
          const averageOpticianPrice = checkedSunglasses.dataset.averageOpticianPrice;
          if (averageOpticianPrice) {
            const priceValue = parseFloat(averageOpticianPrice);
            if (!isNaN(priceValue)) {
              totalAverageOpticianPrice += priceValue;
            }
          }

          const variantProductTitle = checkedSunglasses.dataset.variantTitle;
          if (variantProductTitle) {
            selectedVariantTitles.push(variantProductTitle);
          }

          const priceAttr = checkedSunglasses.getAttribute("variant-price");
          const compareAttr = checkedSunglasses.getAttribute(
            "variant-compare-at-price"
          );

          let price = parseFloat(priceAttr);
          if (isNaN(price) || priceAttr === null || priceAttr === undefined) {
            price = 0;
          }

          let compareAtPrice = parseFloat(compareAttr);
          if (
            isNaN(compareAtPrice) ||
            compareAttr === null ||
            compareAttr === undefined
          ) {
            compareAtPrice = 0;
          }

          totalPrice += price;
          totalCompareAtPrice += compareAtPrice;
        }
      } else {
        selectedInputs.forEach((input) => {
          const priceAttr = input.getAttribute("variant-price");
          const compareAttr = input.getAttribute("variant-compare-at-price");

          let price = parseFloat(priceAttr);
          if (isNaN(price) || priceAttr === null || priceAttr === undefined) {
            price = 0;
          }

          let compareAtPrice = parseFloat(compareAttr);
          if (
            isNaN(compareAtPrice) ||
            compareAttr === null ||
            compareAttr === undefined
          ) {
            compareAtPrice = 0;
          }

          totalPrice += price;
          totalCompareAtPrice += compareAtPrice;
        });
      }
    }

    if (variantPriceInput && !isNaN(parseFloat(variantPriceInput.value))) {
      totalPrice += parseFloat(variantPriceInput.value);
    }
    if (
      variantCompareAtPriceInput &&
      !isNaN(parseFloat(variantCompareAtPriceInput.value))
    ) {
      totalCompareAtPrice += parseFloat(variantCompareAtPriceInput.value);
    }

    if (subscriptionInput && subscriptionInput.checked) {
      const subscriptionPrice = subscriptionInput.dataset.subscriptionPrice;
      const subscriptionOpticianPrice = subscriptionInput.dataset.subscriptionOpticianPrice;

      if (subscriptionOpticianPrice && !isNaN(parseFloat(subscriptionOpticianPrice))) {
        totalAverageOpticianPrice += parseFloat(subscriptionOpticianPrice);
      }

      if (subscriptionBanner) {
        subscriptionBanner.classList.add('active');
        const bannerText = subscriptionBanner.querySelector('.subscription-banner-text');
        if (bannerText && subscriptionPrice && !isNaN(parseFloat(subscriptionPrice))) {
          const formattedPrice = formatMoneyShopify(subscriptionPrice) + " " + productPageElement.dataset.currency;
          const template = bannerText.getAttribute('data-banner-template');
          if (template) {
            bannerText.innerHTML = template.replace('{price}', formattedPrice);
          }
        }
      }
    } else {
      if (subscriptionBanner) {
        subscriptionBanner.classList.remove('active');
      }
    }

    const isExchangeProduct = (productPageElement.getAttribute('template') || '').startsWith('exchange');
    const mainProductEligible = isExchangeProduct || productPageElement.dataset.subscriptionMainEligible === 'true';
    const frameAmount = mainProductEligible ? 0 : (parseFloat(variantPriceInput?.value) || 0);
    const lensAmount = Math.max(0, totalPrice - frameAmount);
    const discountRate = Number(window.subscriptionDiscountPercentage) || 33;
    const subscriptionSaving = Math.round(lensAmount * discountRate / 100);
    const buttonPrice = subscriptionInput?.checked ? totalPrice - subscriptionSaving : totalPrice;
    addToCartButton.innerHTML = formatMoneyShopify(buttonPrice) + " " + productPageElement.dataset.currency;
    const buttonComparePrice = document.querySelector("#add-to-cart-button .gpi-atc-compare");
    if (buttonComparePrice) {
      buttonComparePrice.textContent = formatMoneyShopify(totalCompareAtPrice) + " " + productPageElement.dataset.currency;
      buttonComparePrice.hidden = totalCompareAtPrice <= buttonPrice;
    }
    addToCartCompareAtPrice.innerHTML = formatMoneyShopify(totalCompareAtPrice) + " " + productPageElement.dataset.currency;
    addToCartButtonPrice.innerHTML = formatMoneyShopify(buttonPrice) + " " + productPageElement.dataset.currency;

    const dynamicFinalPriceElement = document.querySelector(".lens-dynamic-prices .final-price");
    if (dynamicFinalPriceElement) {
      let framePrice = 0;
      if (window.single_vison?.product_frame_price) {
        framePrice = parseInt(window.single_vison.product_frame_price, 10);
      }

      let lensOnlyPrice = totalPrice - framePrice;
      if (lensOnlyPrice < 0) lensOnlyPrice = 0;

      dynamicFinalPriceElement.innerHTML = formatMoneyShopify(lensOnlyPrice) + " " + productPageElement.dataset.currency;

      const lensPriceScope = dynamicFinalPriceElement.closest(".gpi-frame-summary") || dynamicFinalPriceElement.closest(".lens-dynamic-prices");
      const dynamicFinalCompareAtPriceElement = lensPriceScope.querySelector(".final-compare-at-price");
      if (dynamicFinalCompareAtPriceElement) {
        let frameCompareAtPrice = 0;
        if (window.single_vison?.product_frame_compare_at_price) {
          frameCompareAtPrice = parseInt(window.single_vison.product_frame_compare_at_price, 10);
        }

        let lensOnlyCompareAtPrice = totalCompareAtPrice - frameCompareAtPrice;
        if (lensOnlyCompareAtPrice < 0) lensOnlyCompareAtPrice = 0;

        if (lensOnlyCompareAtPrice > lensOnlyPrice) {
          dynamicFinalCompareAtPriceElement.innerHTML = "<span>" + formatMoneyShopify(lensOnlyCompareAtPrice) + " " + productPageElement.dataset.currency + "</span>";
          dynamicFinalCompareAtPriceElement.style.display = "";
        } else {
          dynamicFinalCompareAtPriceElement.innerHTML = "";
          dynamicFinalCompareAtPriceElement.style.display = "none";
        }
      }
    }

    if (subscriptionProductSavedAmount) {
      const label = subscriptionProductSavedAmount.closest('.subscription-product-save-text');
      if (label && !label.dataset.additionalSavings) {
        label.replaceChildren(document.createTextNode('Spar yderligere '), subscriptionProductSavedAmount, document.createTextNode(' på denne ordre'));
        label.dataset.additionalSavings = 'true';
      }
      subscriptionProductSavedAmount.textContent = formatMoneyShopify(subscriptionSaving) + " " + productPageElement.dataset.currency;
    }

    const templateAttribute = productPageElement.getAttribute('template');
    if (templateAttribute && templateAttribute.startsWith('exchange')) {
      const productPriceOriginal = document.querySelector(".product-price-container .product-price--original");
      const productPriceCompare = document.querySelector(".product-price-container .product-price--compare");

      if (productPriceOriginal) {
        productPriceOriginal.innerHTML = formatMoneyShopify(totalPrice) + " " + productPageElement.dataset.currency;
      }
      if (productPriceCompare) {
        if (totalCompareAtPrice > totalPrice) {
          productPriceCompare.innerHTML = "<span>" + formatMoneyShopify(totalCompareAtPrice) + " " + productPageElement.dataset.currency + "</span>";
          productPriceCompare.style.display = "";
        } else {
          productPriceCompare.innerHTML = "";
          productPriceCompare.style.display = "none";
        }
      }
    }

    if (averageOpticianPriceElement) {
      const finalAverageOpticianPrice = totalAverageOpticianPrice + originalMetafieldValue;
      averageOpticianPriceElement.innerHTML = formatMoneyShopify(finalAverageOpticianPrice) + " " + productPageElement.dataset.currency;
      
      const averageOpticianPriceContainer = averageOpticianPriceElement.closest('.average-optician-price');
      if (averageOpticianPriceContainer) {
        averageOpticianPriceContainer.setAttribute('data-optician-price', finalAverageOpticianPrice);
      }
    }

    if (averageOpticianPriceSpan) {
      const finalAverageOpticianPrice = totalAverageOpticianPrice + originalMetafieldValue;
      averageOpticianPriceSpan.innerHTML = formatMoneyShopify(finalAverageOpticianPrice) + " " + productPageElement.dataset.currency;
      
      const averageOpticianPriceContainer = averageOpticianPriceSpan.closest('.average-optician-price');
      if (averageOpticianPriceContainer) {
        averageOpticianPriceContainer.setAttribute('data-optician-price', finalAverageOpticianPrice);
      }
    }

    if (selectedVariantTitles.length > 0) {
      if (selectedSubproductNamesElement) {
        selectedSubproductNamesElement.innerHTML = selectedVariantTitles.join(", ");
      }
    }

    if (window.single_vison) {
      window.single_vison.product_total_price = totalPrice;
      window.single_vison.product_total_compare_at_price = totalCompareAtPrice;
    }

    updateOpticianPriceVisibility();
  }

  for (const category in groupIds) {
    groupIds[category].forEach((id) => {
      const input = document.getElementById(id);
      if (input) {
        input.addEventListener("change", () => {
          logTotalPrices();
        });
      }
    });
  }

  sunglassesIds.forEach((id) => {
    const input = document.getElementById(id);
    if (input) {
      input.addEventListener("change", () => {
        logTotalPrices();
      });
    }
  });

  purposeIds.forEach((id) => {
    const input = document.getElementById(id);
    if (input) {
      input.addEventListener("change", () => {
        logTotalPrices();
      });
    }
  });

  if (variantPriceInput) {
    variantPriceInput.addEventListener("change", () => {
      logTotalPrices();
    });
  }

  if (variantCompareAtPriceInput) {
    variantCompareAtPriceInput.addEventListener("change", () => {
      logTotalPrices();
    });
  }

  // Add event listener for subscription input
  if (subscriptionInput) {
    subscriptionInput.addEventListener("change", () => {
      logTotalPrices();
    });
  }

  logTotalPrices();

  updateOpticianPriceVisibility();

  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-optician-price') {
        shouldUpdate = true;
      }
    });
    
    if (shouldUpdate) {
      updateOpticianPriceVisibility();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-optician-price']
  });

  document.addEventListener('optician-price-updated', updateOpticianPriceVisibility);
});
